import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StarIcon from '@mui/icons-material/Star';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { Badge, IconButton, Stack, alpha, useTheme } from '@mui/material';
import spotifyIcon from 'assets/spotify-icon.svg';
import { MediaListItem } from 'components/common/MediaListItem';
import { TrackCover } from 'components/track/TrackCover';
import { useMusicPlayer } from 'contexts/MusicPlayerContext';
import { useUser } from 'hooks/useUser';
import { Track, TrackVendor } from 'models/Track';
import { TrackRequest, TrackRequesterPriorityValue } from 'models/TrackRequest';
import { useTranslation } from 'react-i18next';
import { isRequestTypeTrack } from 'utils/isRequestTypeTrack';
import { VipActionMenu } from './actionMenu/VipActionMenu';

export interface RequestEntryProps {
  request: TrackRequest;
  onRemoveRequest?(request: TrackRequest): void;
  onRequest?(request: TrackRequest): void;
  canRequest?: boolean;
  onPreview?(track: Track): void;
  onClosePreview?(): void;
  vip?: boolean;
  onChangeRequestMessage?: (message: string) => void;
  onChangeRequestPriority?: (value: TrackRequesterPriorityValue) => void;
}

export function RequestEntry({
  request,
  onRemoveRequest,
  onRequest,
  canRequest,
  onPreview,
  onClosePreview,
  vip,
  onChangeRequestMessage,
  onChangeRequestPriority,
}: RequestEntryProps) {
  const { t } = useTranslation();
  const { requesterId } = useUser();
  const { pause } = useMusicPlayer();
  const theme = useTheme();
  // const [canRemove, setCanRemove] = useState(false);
  // const isVerySmallScreen = useMediaQuery('(max-width:450px)');
  const isRequestedByCurrentUser = request.requesters?.some(({ id }) => id === requesterId);
  const requestCount = request.requesters?.length ?? 0;

  const title = isRequestTypeTrack(request.value) ? request.value.title : request.value;
  const artist = isRequestTypeTrack(request.value) ? request.value.artist : undefined;
  const track = isRequestTypeTrack(request.value) ? request.value : undefined;
  const isSpotifyTrack =
    isRequestTypeTrack(request.value) && request.value.vendor === TrackVendor.Spotify;

  const hasPreviewUrl = !!track?.previewUrl?.trim();
  const hasVendorUrl = !!track?.vendorUrl?.trim();

  const requesterMessage = request.messages?.find((message) => vip && message.id == requesterId);

  const requesterPriority = request.priorities?.find(
    (priority) => vip && priority.id == requesterId
  );

  // const removeTimeout = 300;
  // const removeCheckInterval = 1000;

  // const canRemoveExpired = () => {
  //   const requestDate = request.requesters?.find(({ id }) => id === requesterId)?.date;

  //   return dayjs().isAfter(dayjs(requestDate).add(removeTimeout, 'second'));
  // };

  // useEffect(() => {
  //   if (!isRequestedByCurrentUser) {
  //     return;
  //   }

  //   setCanRemove(!canRemoveExpired());

  //   const interval = setInterval(() => {
  //     setCanRemove(!canRemoveExpired());
  //   }, removeCheckInterval);

  //   return () => clearInterval(interval);
  // }, [isRequestedByCurrentUser, request.requesters, requesterId]);

  const handleRequestToggle = () => {
    // console.log(isRequestedByCurrentUser, canRemove);

    if (isRequestedByCurrentUser) {
      // if (canRemove) {
      onRemoveRequest?.(request);
      // }
    } else {
      onRequest?.(request);
      // setCanRemove(true);
    }
  };

  const handleSpotifyClick = () => {
    if (!track) return;
    pause();
    onClosePreview?.();
    window.open(track.vendorUrl, '_blank');
  };

  const badgeContent =
    requesterPriority?.value === TrackRequesterPriorityValue.High ? (
      <StarIcon sx={{ fontSize: 14 }} />
    ) : requesterPriority?.value === TrackRequesterPriorityValue.Low ? (
      <ThumbDownIcon sx={{ fontSize: 14 }} />
    ) : isRequestedByCurrentUser ? (
      <ThumbUpIcon sx={{ fontSize: 14 }} />
    ) : null;

  const badgeColorKey =
    requesterPriority?.value === TrackRequesterPriorityValue.High
      ? 'warning'
      : requesterPriority?.value === TrackRequesterPriorityValue.Low
      ? 'error'
      : 'primary';

  // const BadgeContent = () => {
  //   const isRequestedByCurrentUser = request.requesters?.some(({ id }) => id === requesterId);

  //   const badgeColorKey =
  //     requesterPriority?.value === TrackRequesterPriorityValue.High
  //       ? 'warning'
  //       : requesterPriority?.value === TrackRequesterPriorityValue.Low
  //       ? 'error'
  //       : 'primary';

  //   return (
  //     <Stack
  //       direction="row"
  //       sx={{
  //         borderRadius: 5,
  //         overflow: 'hidden',
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           backgroundColor: (theme) => theme.palette.background.paper,
  //           color: (theme) => theme.palette.text.primary,
  //           // borderRadius: '50%',
  //           width: 16,
  //           height: 16,
  //           padding: 1.25,
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //         }}
  //       >
  //         {requestCount}
  //       </Box>
  //       {isRequestedByCurrentUser && (
  //         <Box
  //           sx={{
  //             backgroundColor: (theme) => theme.palette[badgeColorKey].main,
  //             color: (theme) => theme.palette[badgeColorKey].contrastText,
  //             // borderRadius: '50%',
  //             width: 16,
  //             height: 16,
  //             padding: 1.25,
  //             display: 'flex',
  //             alignItems: 'center',
  //             justifyContent: 'center',
  //           }}
  //         >
  //           {requesterPriority?.value === TrackRequesterPriorityValue.High ? (
  //             <StarIcon sx={{ fontSize: 14 }} />
  //           ) : requesterPriority?.value === TrackRequesterPriorityValue.Low ? (
  //             <ThumbDownIcon sx={{ fontSize: 14 }} />
  //           ) : isRequestedByCurrentUser ? (
  //             <ThumbUpIcon sx={{ fontSize: 14 }} />
  //           ) : null}
  //         </Box>
  //       )}
  //     </Stack>
  //   );
  // };

  const background =
    requesterPriority?.value === TrackRequesterPriorityValue.High
      ? `linear-gradient(90deg, ${alpha(theme.palette.warning.main, 0.12)} 0%, transparent 100%)`
      : requesterPriority?.value === TrackRequesterPriorityValue.Low
      ? `linear-gradient(90deg, ${alpha(theme.palette.error.main, 0.12)} 0%, transparent 100%)`
      : isRequestedByCurrentUser
      ? `linear-gradient(90deg, ${alpha(theme.palette.primary.main, 0.12)} 0%, transparent 100%)`
      : 'transparent';

  // const backgroundColor =
  //   requesterPriority?.value === TrackRequesterPriorityValue.High
  //     ? alpha(theme.palette.warning.main, 0.12)
  //     : requesterPriority?.value === TrackRequesterPriorityValue.Low
  //     ? alpha(theme.palette.error.main, 0.12)
  //     : 'transparent';

  return (
    <MediaListItem
      sx={{ background }}
      media={
        //   isRequestTypeTrack(request.value) ? (
        //     <TrackCover title={title} cover={request.value.artworkUrl} />
        //   ) : (
        //     <TrackCover title={title} />
        //   )
        // }
        <Badge
          badgeContent={badgeContent}
          color={badgeColorKey}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {isRequestTypeTrack(request.value) ? (
            <TrackCover title={title} cover={request.value.artworkUrl} />
          ) : (
            <TrackCover title={title} fallback={'TEXT'} />
          )}
        </Badge>
      }
      onClick={
        canRequest
          ? () => {
              handleRequestToggle();
            }
          : undefined
      }
      title={title}
      subtitle={
        <Stack direction="row" gap={1}>
          <Stack direction="row" gap={0.5}>
            <ThumbUpIcon sx={{ fontSize: 14 }} />
            {requestCount}
          </Stack>
          {requesterMessage && (
            <Stack direction="row" gap={0.5}>
              <ChatBubbleIcon sx={{ fontSize: 14 }} />
              {requesterMessage.value}
            </Stack>
          )}
        </Stack>
      }
      pretitle={
        artist ? (
          <>
            {isSpotifyTrack && hasVendorUrl && (
              <img
                src={spotifyIcon}
                alt="Spotify"
                style={{ width: 12, height: 12, marginRight: 6, verticalAlign: 'center' }}
              />
            )}
            {artist}
          </>
        ) : null
      }
      trailing={
        <>
          {isRequestTypeTrack(request.value) && (
            <IconButton
              onClick={(ev) => {
                ev.stopPropagation();
                if (hasPreviewUrl && track) {
                  onPreview?.(track);
                } else if (isSpotifyTrack && hasVendorUrl) {
                  handleSpotifyClick();
                }
              }}
              disabled={!canRequest}
            >
              {/* {isRequestedByCurrentUser ? (
              <FavoriteIcon color="primary" />
            ) : (
              <FavoriteBorderOutlinedIcon />
            )} */}
              <PlayArrowIcon />
            </IconButton>
          )}
          {vip && (
            <VipActionMenu
              request={request}
              sx={{ ml: 0 }}
              onChangeRequestMessage={onChangeRequestMessage}
              onChangeRequestPriority={onChangeRequestPriority}
            />
          )}
        </>
      }
    />
  );
}
